import React from 'react';

const Step3 = ({ formData, updateFormData }) => {
  const requestTypes = [
    { value: 'DL1', label: 'Αντίγραφο ιατρικού φακέλου νοσηλείας', description: 'Πλήρης ιατρικός φάκελος νοσηλείας' },
    { value: 'DL2', label: 'Αντίγραφο ιατρικού φακέλου νοσηλείας θανόντος', description: 'Απαιτούνται επιπλέον δικαιολογητικά (Πιστοποιητικό συγγενών, Βεβαίωση διαθήκης)' },
    { value: 'DL3', label: 'Αντίγραφο ιατρικού φακέλου επίσκεψης στα ΤΕΠ', description: 'Φάκελος εξωτερικών ιατρείων' },
    { value: 'DL4', label: 'Απεικονιστική εξέταση', description: 'Ακτινογραφία, αξονική, μαγνητική, υπέρηχο, κ.λπ.' },
    { value: 'DL5', label: 'Πόρισμα εξέτασης', description: 'Αποτελέσματα απεικονιστικών/εργαστηριακών εξετάσεων' },
    { value: 'DL6', label: 'Μικροβιολογικές εξετάσεις', description: 'Αποτελέσματα μικροβιολογικών εξετάσεων' },
    { value: 'DL7', label: 'Πρακτικό χειρουργείου', description: 'Πρακτικό χειρουργικής επέμβασης' },
    { value: 'DL8', label: 'Τοξικολογικές', description: 'Τοξικολογικές εξετάσεις' },
    { value: 'DL9', label: 'Εξιτήριο', description: 'Εξιτήριο νοσηλείας' },
    { value: 'DL10', label: 'Βεβαίωση νοσηλείας', description: 'Βεβαίωση περιόδου νοσηλείας' },
    { value: 'DL11', label: 'Ιατρική γνωμάτευση νοσηλείας', description: 'Γνωμάτευση από νοσηλεία' },
    { value: 'DL12', label: 'Συγκεντρωτική κατάσταση νοσηλειών', description: 'Ιστορικό όλων των νοσηλειών' },
    { value: 'DL13', label: 'Υποβολή παραπόνων/θετικών σχολίων', description: 'Υποβολή σχολίων για το νοσοκομείο' },
    { value: 'DL14', label: 'Άλλο', description: 'Άλλο αίτημα (παρακαλώ περιγράψτε)' }
  ];

  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  const selectedRequest = requestTypes.find(t => t.value === formData.requestType);

  return (
    <div>
      <h3>Βήμα 3: Επιπρόσθετα Στοιχεία Αιτήματος</h3>
      <p className="mb-20">Παρακαλώ επιλέξτε το είδος του αιτήματός σας από τη λίστα:</p>

      <div className="form-group">
        <label htmlFor="requestType">
          Είδος Αιτήματος <span className="required">*</span>
        </label>
        <select
          id="requestType"
          name="requestType"
          value={formData.requestType}
          onChange={handleChange}
          required
          style={{ fontSize: '16px', padding: '14px' }}
        >
          <option value="">Επιλέξτε από τη λίστα</option>
          {requestTypes.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      {selectedRequest && (
        <div className="alert alert-info">
          <h4 style={{ marginTop: 0 }}>
            <strong>✓ Επιλέχθηκε:</strong> {selectedRequest.label}
          </h4>
          <p style={{ margin: '10px 0 0 0', fontSize: '14px' }}>
            {selectedRequest.description}
          </p>
        </div>
      )}

      {formData.requestType === 'DL2' && (
        <div className="alert" style={{ 
          background: '#fff3cd', 
          borderLeft: '4px solid #ffc107', 
          padding: '15px',
          marginTop: '20px'
        }}>
          <strong>⚠️ Προσοχή:</strong> Για αντίγραφο ιατρικού φακέλου θανόντος απαιτούνται:
          <ul style={{ marginLeft: '20px', marginTop: '10px', marginBottom: 0 }}>
            <li>Πιστοποιητικό Εγγυτέρων Συγγενών από το Δήμο</li>
            <li>Βεβαίωση περί μη Δημοσίευσης Διαθήκης από το Πρωτοδικείο ή Αντίγραφο Διαθήκης</li>
          </ul>
          <p style={{ margin: '10px 0 0 0', fontSize: '14px' }}>
            Θα σας ζητηθούν στο επόμενο βήμα.
          </p>
        </div>
      )}

      {formData.requestType === 'DL13' && (
        <div className="alert alert-info">
          <strong>💬 Σχόλια:</strong> Στο επόμενο βήμα θα σας ζητηθεί να συμπληρώσετε 
          τα σχόλια ή τα παράπονά σας σχετικά με τις υπηρεσίες του νοσοκομείου.
        </div>
      )}

      {formData.requestType === 'DL14' && (
        <div className="alert alert-info">
          <strong>📝 Άλλο αίτημα:</strong> Παρακαλούμε όπως υποβάλετε το αίτημά σας με 
          σαφήνεια και όλα τα απαραίτητα στοιχεία για την ταχύτερη εξυπηρέτησή σας.
        </div>
      )}

      {formData.requestType && formData.requestType !== 'DL2' && formData.requestType !== 'DL13' && formData.requestType !== 'DL14' && (
        <div className="alert alert-info">
          <strong>➡️ Επόμενο βήμα:</strong> Θα σας ζητηθούν συγκεκριμένα στοιχεία 
          για το αίτημά σας (ΑΜΚΑ, ημερομηνίες, κλινική, κ.λπ.)
        </div>
      )}
    </div>
  );
};

export default Step3;




